import { useTranslation, getI18n } from 'react-i18next';
export var FormmattedMessage = function (props) {
    var t = useTranslation().t;
    return t(props.id);
};
export var formmattedMessage = function (props) {
    return getI18n().t(props.id);
};
